var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"owal panel header button",on:{"click":function($event){return _vm.handleClick(_vm.identifier)}}},[_vm._v(" "+_vm._s(this.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }